import type { GatsbyBrowser } from 'gatsby'
import React from 'react'
import 'ress'

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => {
  return <>{element}</>
}
